import React from 'react'

import Input from 'Components/Input'

export default React.memo(props => <Input disabled={props.disabled} title={props.title}
             onChange={props.onChangeInput}
             style={{ width: '100%' }}
             type={'text'}
             value={props.data} id={props.name}/>)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/InputTextBasic.js